import { render, staticRenderFns } from "./login-subform.vue?vue&type=template&id=2ecec534&scoped=true"
import script from "./login-subform.vue?vue&type=script&lang=js"
export * from "./login-subform.vue?vue&type=script&lang=js"
import style0 from "./login-subform.vue?vue&type=style&index=0&id=2ecec534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecec534",
  null
  
)

export default component.exports